import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAppSelector } from '@/hooks/useAppSelector';
import { invalidate } from '@/lib/query/invalidate';

/**
 * Refetches company-scoped React Query data when the header company switcher changes,
 * replacing full route remount via {@code Outlet key={companyScopeVersion}}.
 */
export function useCompanyScopeQuerySync(): void {
  const qc = useQueryClient();
  const companyScopeVersion = useAppSelector((s) => s.app.companyScopeVersion);
  const selectedCompanyId = useAppSelector((s) => s.app.selectedCompany?.id ?? null);
  const initialVersion = useRef(companyScopeVersion);

  useEffect(() => {
    if (companyScopeVersion === initialVersion.current) {
      return;
    }
    invalidate.companyScope(qc, selectedCompanyId);
  }, [companyScopeVersion, selectedCompanyId, qc]);
}
